import Base from './base';
import { default as UnderlyingSelect, SELECT_EVENT } from './underlying-select';

class UnderlyingSelectLink extends Base {
	constructor(el) {
		super(el);

		this.underlyingSelect = new UnderlyingSelect({ el: this.refs.select });
		this.underlyingSelect.el.addEventListener(SELECT_EVENT, e => this.onUnderlyingSelected(e));
	}

	async start() {
		const { options: { underlyingApiUrl, preselected, exchangesToExclude, exchangesToInclude } } = this;

		if (!underlyingApiUrl) {
			console.warn('cannot create quick links without feedUrl');

			return;
		}

		this.isLoading = true;

		const trabeableApiUrl = `${underlyingApiUrl}/tradeable?exchangesToExclude=${exchangesToExclude}&exchangesToInclude=${exchangesToInclude}`;

		try {
			await this.underlyingSelect.init(trabeableApiUrl);

			this.underlyingSelect.select(preselected);
		} catch (e) {
			console.warn('error while fetching:', e);
		} finally {
			this.isLoading = false;
		}
	}

	onUnderlyingSelected(e) {
		const { detail: underlying } = e;

		this.gotoPage(underlying);
	}

	gotoPage(underlying) {
		let { url } = underlying;
		const { key, urlFriendlyName } = underlying;

		if (this.options.relativeUrl) {
			url = `${UnderlyingSelectLink.pageUrl}?u=${key}&underlying=${urlFriendlyName}`;
		}

		window.location = url;
	}

	static get pageUrl() {
		const { location: { pathname } } = window;

		return pathname;
	}
}

export default UnderlyingSelectLink;
